import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import type {DCULPath} from "@khan/assignments-types";
import {useTeacherAccessPermissions} from "@khan/teacher-access-permissions";

/**
 * We need to be smart here and only create a new Loadable once rather than
 * every render. So let's cache the first one we make then reuse it.
 */
const CreateActivityAssignmentModalComponent = React.lazy(
    () => import("./create-single-content-assignment-modal-provider.ts"),
);

interface Props {
    contentDescriptor: string;
    contentPath?: DCULPath;
    initialAssignment?: any;
    onSuccess?: () => unknown;
    onClose?: () => unknown;
}

const AsyncCreateActivityAssignmentModal = (props: Props): React.ReactNode => {
    // Hooks
    const teacherAccessPermissionsResult = useTeacherAccessPermissions();

    const {
        contentDescriptor,
        contentPath,
        initialAssignment,
        onSuccess,
        onClose,
    } = props;
    const courseSlug = "ai-activities";

    if (
        teacherAccessPermissionsResult.status !== "success" ||
        !teacherAccessPermissionsResult.data.canAssignAssignments
    ) {
        return null;
    }

    return (
        <React.Suspense
            fallback={
                <div className={css(styles.assignmentLoadingIndicator)}>
                    <CircularSpinner size="xsmall" />
                </div>
            }
        >
            <CreateActivityAssignmentModalComponent
                contentDescriptor={contentDescriptor}
                contentPath={contentPath}
                initialAssignment={initialAssignment}
                subjectSlug={courseSlug}
                onClose={onClose}
                onSuccess={onSuccess}
            />
        </React.Suspense>
    );
};

const styles = StyleSheet.create({
    assignmentLoadingIndicator: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});

export default AsyncCreateActivityAssignmentModal;
